import type {
  NormalizedProduct,
  RawSupplierProduct,
  SupplierId,
  SupplierInfo,
} from '../types'

/**
 * Connector contract — each supplier is an independent adapter.
 * Adding a new supplier = implement this interface + register in registry.
 */
export interface ISupplierConnector {
  readonly info: SupplierInfo

  login(): Promise<boolean>
  search(term: string): Promise<RawSupplierProduct[]>
  getProduct(id: string): Promise<RawSupplierProduct | null>
  normalize(raw: RawSupplierProduct): NormalizedProduct
  healthCheck(): Promise<boolean>
}

export type ConnectorFactory = () => ISupplierConnector

export const SUPPLIERS: Record<SupplierId, SupplierInfo> = {
  pauta: { id: 'pauta', name: 'Pauta', kind: 'distributor' },
  oderco: { id: 'oderco', name: 'Oderço', kind: 'distributor' },
  agis: { id: 'agis', name: 'Agis', kind: 'distributor' },
  allnations: { id: 'allnations', name: 'All Nations', kind: 'distributor' },
  ingram: { id: 'ingram', name: 'Ingram Micro', kind: 'distributor' },
  snd: { id: 'snd', name: 'SND', kind: 'distributor' },
  kabum: { id: 'kabum', name: 'KaBuM!', kind: 'retail' },
  terabyte: { id: 'terabyte', name: 'Terabyte', kind: 'retail' },
  pichau: { id: 'pichau', name: 'Pichau', kind: 'retail' },
  amazon: { id: 'amazon', name: 'Amazon', kind: 'marketplace' },
  mercadolivre: { id: 'mercadolivre', name: 'Mercado Livre', kind: 'marketplace' },
  magazineluiza: { id: 'magazineluiza', name: 'Magazine Luiza', kind: 'marketplace' },
}

export const ALL_SUPPLIER_IDS = Object.keys(SUPPLIERS) as SupplierId[]
